export default __webpack_public_path__ + "static/media/ticketnumber.196b81b8.jpeg";